export const testAttributes = {
    COMPLIANCE_BANNER_CONTAINER: 'COMPLIANCE_BANNER_CONTAINER'
}
export const boxProps = {
    DEFAULT_MESSAGE: "Welcome to the new Quicken Loans, the cutting-edge online marketplace transforming the way you find financial providers.",
    BOX_TYPE: "info"
}